import React from 'react';

// Generic Icons

export const Logo = props => (
	<svg {...props} viewBox="0 0 36 58.439899">
		<path
			fill="#fff"
			d="M24.747 49.085c-3.566 4.444-8.337 3.986-13.99-.43L8.414 46.84 18.72 33.65l2.604 2.028c5.87 4.394 6.83 9.026 3.423 13.407m2.84-37.487L17.28 24.792l-2.584-2.034c-5.87-4.394-6.848-9.023-3.442-13.404 3.565-4.444 8.337-3.985 13.99.432l2.342 1.812zm2.152 41.265c2.81-3.604 3.68-7.335 2.9-11.337-.92-3.937-2.88-6.82-7-10.295l-3.127-2.44C28.97 20.53 35.24 12.5 35.64 11.99c.74-.945.084-1.47.084-1.47l-3.58-2.8v.003L30.04 6.07C26.73 3.48 24.048 1.756 22 .894 19.93.018 17.93-.15 15.634.11c-3.997.44-6.744 2.1-9.372 5.467C3.445 9.182 2.58 12.91 3.358 16.914c.92 3.937 2.876 6.824 6.992 10.296l3.125 2.45C7.02 37.92.75 45.945.352 46.456c-.742.948-.083 1.47-.083 1.47l3.58 2.798 2.1 1.646c3.32 2.583 6 4.31 8.05 5.17 2.063.874 4.07 1.042 6.36.78 4-.434 6.744-2.098 9.375-5.464"
		/>
	</svg>
);

// Icons for Navigation Bar

export const Back = props => (
	<svg
		{...props}
		width="48"
		height="48"
		version="1.1"
		viewBox="0 0 48 48"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			strokeWidth="0"
			d="m2 0c-1.108 0-2 0.892-2 2v10c0 1.108 0.892 2 2 2h10c1.108 0 2-0.892 2-2v-10c0-1.108-0.892-2-2-2zm17 0c-1.108 0-2 0.892-2 2v10c0 1.108 0.892 2 2 2h10c1.108 0 2-0.892 2-2v-10c0-1.108-0.892-2-2-2zm17 0c-1.108 0-2 0.892-2 2v10c0 1.108 0.892 2 2 2h10c1.108 0 2-0.892 2-2v-10c0-1.108-0.892-2-2-2zm-32.6 2h7.1992c0.7756 0 1.4004 0.6248 1.4004 1.4004v7.1992c0 0.7756-0.62479 1.4004-1.4004 1.4004h-7.1992c-0.7756 0-1.4004-0.6248-1.4004-1.4004v-7.1992c0-0.7756 0.62479-1.4004 1.4004-1.4004zm17 0h7.1992c0.7756 0 1.4004 0.6248 1.4004 1.4004v7.1992c0 0.7756-0.62479 1.4004-1.4004 1.4004h-7.1992c-0.7756 0-1.4004-0.6248-1.4004-1.4004v-7.1992c0-0.7756 0.62479-1.4004 1.4004-1.4004zm17 0h7.1992c0.7756 0 1.4004 0.6248 1.4004 1.4004v7.1992c0 0.7756-0.62479 1.4004-1.4004 1.4004h-7.1992c-0.7756 0-1.4004-0.6248-1.4004-1.4004v-7.1992c0-0.7756 0.62479-1.4004 1.4004-1.4004zm-35.4 15c-1.108 0-2 0.892-2 2v10c0 1.108 0.892 2 2 2h10c1.108 0 2-0.892 2-2v-10c0-1.108-0.892-2-2-2zm17 0c-1.108 0-2 0.892-2 2v10c0 1.108 0.892 2 2 2h10c1.108 0 2-0.892 2-2v-10c0-1.108-0.892-2-2-2zm17 0c-1.108 0-2 0.892-2 2v10c0 1.108 0.892 2 2 2h10c1.108 0 2-0.892 2-2v-10c0-1.108-0.892-2-2-2zm-32.6 2h7.1992c0.7756 0 1.4004 0.6248 1.4004 1.4004v7.1992c0 0.7756-0.62479 1.4004-1.4004 1.4004h-7.1992c-0.7756 0-1.4004-0.6248-1.4004-1.4004v-7.1992c0-0.7756 0.62479-1.4004 1.4004-1.4004zm17 0h7.1992c0.7756 0 1.4004 0.6248 1.4004 1.4004v7.1992c0 0.7756-0.62479 1.4004-1.4004 1.4004h-7.1992c-0.7756 0-1.4004-0.6248-1.4004-1.4004v-7.1992c0-0.7756 0.62479-1.4004 1.4004-1.4004zm17 0h7.1992c0.7756 0 1.4004 0.6248 1.4004 1.4004v7.1992c0 0.7756-0.62479 1.4004-1.4004 1.4004h-7.1992c-0.7756 0-1.4004-0.6248-1.4004-1.4004v-7.1992c0-0.7756 0.62479-1.4004 1.4004-1.4004zm-35.4 15c-1.108 0-2 0.892-2 2v10c0 1.108 0.892 2 2 2h10c1.108 0 2-0.892 2-2v-10c0-1.108-0.892-2-2-2zm17 0c-1.108 0-2 0.892-2 2v10c0 1.108 0.892 2 2 2h10c1.108 0 2-0.892 2-2v-10c0-1.108-0.892-2-2-2zm17 0c-1.108 0-2 0.892-2 2v10c0 1.108 0.892 2 2 2h10c1.108 0 2-0.892 2-2v-10c0-1.108-0.892-2-2-2zm-32.6 2h7.1992c0.7756 0 1.4004 0.6248 1.4004 1.4004v7.1992c0 0.7756-0.62479 1.4004-1.4004 1.4004h-7.1992c-0.7756 0-1.4004-0.6248-1.4004-1.4004v-7.1992c0-0.7756 0.62479-1.4004 1.4004-1.4004zm17 0h7.1992c0.7756 0 1.4004 0.6248 1.4004 1.4004v7.1992c0 0.7756-0.62479 1.4004-1.4004 1.4004h-7.1992c-0.7756 0-1.4004-0.6248-1.4004-1.4004v-7.1992c0-0.7756 0.62479-1.4004 1.4004-1.4004zm17 0h7.1992c0.7756 0 1.4004 0.6248 1.4004 1.4004v7.1992c0 0.7756-0.62479 1.4004-1.4004 1.4004h-7.1992c-0.7756 0-1.4004-0.6248-1.4004-1.4004v-7.1992c0-0.7756 0.62479-1.4004 1.4004-1.4004z"
		/>
	</svg>
);

export const BackArrow = props => (
	<svg
		{...props}
		viewBox="0 0 24 24"
		width="24"
		height="24"
		strokeWidth="1"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<path d="m 0.5,12.5 23,0 M 0,12.5 Z m 6.5,-6 -6,6 6,6 -6,-6" />
	</svg>
);

export const CloseCross = props => (
	<svg
		{...props}
		width="48"
		height="48"
		version="1.1"
		viewBox="0 0 48 48"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			strokeWidth="0"
			d="m7.7383 6.7383a1.0001 1.0001 0 0 0 -0.69727 1.7168l15.545 15.545-15.545 15.545a1.0001 1.0001 0 1 0 1.4141 1.4141l15.545-15.545 15.545 15.545a1.0001 1.0001 0 1 0 1.4141 -1.4141l-15.545-15.545 15.545-15.545a1.0001 1.0001 0 0 0 -0.72656 -1.7168 1.0001 1.0001 0 0 0 -0.6875 0.30273l-15.545 15.545-15.545-15.545a1.0001 1.0001 0 0 0 -0.7168 -0.30273z"
		/>
	</svg>
);

export const Expand = props => (
	<svg {...props} viewBox="0 0 24 24" fill="white">
		<circle cx="3" cy="12" r="2" />
		<circle cx="12" cy="12" r="2" />
		<circle cx="21" cy="12" r="2" />
	</svg>
);

export const Share = props => (
	<svg
		{...props}
		width="48"
		height="48"
		version="1.1"
		viewBox="0 0 48 48"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			strokeWidth="0"
			d="m1 0a1.0001 1.0001 0 0 0 -1 1v46a1.0001 1.0001 0 0 0 1 1h46a1.0001 1.0001 0 0 0 1 -1v-17.363a1.0001 1.0001 0 1 0 -2 0v16.363h-44v-44h17.221a1.0001 1.0001 0 1 0 0 -2zm31.977 0.17969a1.0001 1.0001 0 0 0 -0.58008 1.7969l11.602 9.043c-2.0626-0.1581-4.0293-0.25848-5.8516-0.27148-6.4432-0.046-11.426 0.77721-15.24 2.1953-5.0859 1.8908-8.0962 4.8911-9.4941 8.207s-1.1926 6.8685-0.1543 9.8848c1.0383 3.0162 2.8809 5.5352 5.0449 6.8594a1.0001 1.0001 0 1 0 1.0449 -1.7051c-1.6056-0.9825-3.292-3.1695-4.1992-5.8047-0.9071-2.6353-1.0637-5.6791 0.10742-8.457 1.171-2.7779 3.66-5.3667 8.3477-7.1094 4.5628-1.6964 11.229-2.5288 20.559-1.7832l-11.766 9.168a1.0001 1.0001 0 1 0 1.2305 1.5762l13.988-10.9a1.0001 1.0001 0 0 0 0 -1.5781l-13.988-10.902a1.0001 1.0001 0 0 0 -0.65039 -0.21875z"
		/>
	</svg>
);

export const ChevronDown = props => (
	<svg {...props} viewBox="0 0 640 640">
		<path d="M557.376 195.488c8.704-8.576 22.688-8.576 31.328 0s8.672 22.432 0 31.008l-253.056 250.56c-8.64 8.576-22.624 8.576-31.328 0l-253.056-250.56c-8.64-8.576-8.64-22.432 0-31.008 8.672-8.576 22.688-8.576 31.328 0l237.408 228.512 237.376-228.512z" />
	</svg>
);

export const User = props => (
	<svg {...props} viewBox="0 0 47 54">
		<path
			fill="#fff"
			d="M30.5,32H15.7C6.8,32,0,41.2,0,52.4C0,53.1,0,54,0.9,54h45.1c0.9,0,0.9-0.9,0.9-1.6C47,41.2,39.4,32,30.5,32z M2,52
				C2.1,42,8.2,34,16,34h14c7.9,0,14.9,7.9,15,18H2z M22.9,28.5c7.8,0,14.2-6.4,14.2-14.2C37.1,6.4,30.7,0,22.9,0S8.6,6.4,8.6,14.2
				C8.6,22.1,15,28.5,22.9,28.5z M22.9,2c6.7,0,12.2,5.5,12.2,12.3c0,0.7-0.1,1.3-0.2,1.9c-6.9-0.5-8.7-5.2-8.7-5.4l-0.7-2l-1.1,1.8
				c-2.6,4.4-11.3,2.8-13.7,2.3C11.4,6.8,16.6,2,22.9,2z M25.1,12.9c1.2,1.8,3.9,4.7,9.4,5.2c-1.6,4.9-6.2,8.4-11.6,8.4
				c-6.5,0-11.9-5.2-12.2-11.6C13.6,15.5,21.3,16.8,25.1,12.9z"
		/>
	</svg>
);

// Icons for Embeds

export const Facebook = () => (
	<svg viewBox="0 0 67 67">
		<path
			fill="#3a589b"
			fillRule="evenodd"
			d="M29.765 50.32h6.744V33.998h4.495l.596-5.624h-5.09l.006-2.816c0-1.466.14-2.253 2.244-2.253h2.812V17.68h-4.5c-5.405 0-7.307 2.73-7.307 7.317v3.377h-3.37V34h3.37v16.32zM34 64C17.432 64 4 50.568 4 34 4 17.43 17.432 4 34 4s30 13.43 30 30c0 16.568-13.432 30-30 30z"
			clipRule="evenodd"
		/>
	</svg>
);

// fuck elon musk
/*export const Twitter = () => (
	<svg viewBox="0 0 67 67">
		<path
			fill="#598dca"
			fillRule="evenodd"
			d="M38.167 22.283c-2.62.953-4.274 3.41-4.086 6.1l.07 1.04-1.05-.128c-3.81-.487-7.14-2.14-9.97-4.915l-1.38-1.377-.35 1.017c-.754 2.267-.272 4.66 1.3 6.27.837.89.648 1.018-.797.488-.504-.17-.944-.296-.986-.233-.144.15.358 2.076.756 2.84.54 1.06 1.65 2.096 2.87 2.71l1.024.488-1.214.02c-1.17 0-1.212.022-1.09.468.42 1.38 2.078 2.84 3.92 3.48l1.3.45-1.13.68a11.75 11.75 0 0 1-5.615 1.57c-.945.02-1.72.11-1.72.17 0 .21 2.557 1.4 4.044 1.868 4.46 1.376 9.76.78 13.74-1.57 2.83-1.673 5.66-5 6.98-8.22.71-1.715 1.425-4.85 1.425-6.354 0-.977.06-1.104 1.235-2.27.69-.68 1.34-1.42 1.465-1.63.21-.404.187-.404-.88-.044-1.78.636-2.034.55-1.153-.4.65-.68 1.426-1.91 1.426-2.27 0-.062-.314.04-.67.234-.377.21-1.215.53-1.844.72l-1.13.36-1.03-.7c-.566-.38-1.36-.805-1.78-.932-1.07-.294-2.705-.252-3.67.087zM34 64C17.432 64 4 50.568 4 34 4 17.43 17.432 4 34 4s30 13.43 30 30c0 16.568-13.432 30-30 30z"
			clipRule="evenodd"
		/>
	</svg>
);*/

export const Twitter = () => (
	<svg viewBox="0 0 67 67">
		<path fill="#000" d="m21.6 20.5 20.2 27h4.6l-20.2-27z"/>
		<path fill="#000" d="m34 4c-16.6 0-30 13.4-30 30s13.4 30 30 30 30-13.4 30-30-13.4-30-30-30zm6.6 45.6-9.2-12.2-11.3 12.2h-2.9l13-14-12.9-17.3h10l8.5 11.3 10.4-11.3h2.9l-12.1 13 13.6 18.3z"/>
	</svg>
);

export const GooglePlus = () => (
	<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
		<path
			xmlns="http://www.w3.org/2000/svg"
			d="M512 48c-256.288 0-464 207.713-464 464s207.713 464 464 464 464-207.712 464-464-207.712-464-464-464zM396 744c-128.325 0-232-103.675-232-232s103.675-232 232-232c62.712 0 115.093 22.837 155.512 60.718l-63.075 60.537c-17.218-16.493-47.307-35.707-92.438-35.707-79.207 0-143.913 65.613-143.913 146.45s64.707 146.45 143.913 146.45c91.893 0 126.332-65.975 131.587-100.050h-131.588v-79.568h219.132c1.993 11.6 3.625 23.2 3.625 38.425 0 132.675-88.813 226.743-222.757 226.743zM802 512v58h-58v-58h-58v-58h58v-58h58v58h58v58h-58z"
		/>
	</svg>
);

export const WhatsApp = () => (
	<svg viewBox="0 0 67 67">
		<path
			fill="#25D366"
			fillRule="evenodd"
			d="M 33.5 2.8007812 A 30.7 30.7 0 0 0 2.8007812 33.5 A 30.7 30.7 0 0 0 33.5 64.199219 A 30.7 30.7 0 0 0 64.199219 33.5 A 30.7 30.7 0 0 0 33.5 2.8007812 z M 33.919922 15.435547 C 38.615754 15.437501 43.023765 17.264034 46.337891 20.582031 C 49.652016 23.899945 51.476293 28.311591 51.474609 33.001953 C 51.470609 42.680378 43.594223 50.554688 33.919922 50.554688 L 33.912109 50.554688 C 30.974216 50.553664 28.089325 49.816424 25.525391 48.417969 L 16.21875 50.859375 L 18.708984 41.763672 C 17.17283 39.101514 16.363972 36.082139 16.365234 32.988281 C 16.369142 23.309941 24.244527 15.435547 33.919922 15.435547 z M 33.925781 18.400391 C 25.878032 18.400391 19.333277 24.946019 19.330078 32.990234 C 19.328869 35.747082 20.100059 38.430946 21.560547 40.753906 L 21.908203 41.306641 L 20.433594 46.689453 L 25.955078 45.240234 L 26.488281 45.556641 C 28.728336 46.88591 31.296008 47.588834 33.914062 47.589844 L 33.919922 47.589844 C 41.961611 47.589844 48.506314 41.044888 48.509766 33 C 48.511161 29.101578 46.994893 25.435423 44.240234 22.677734 C 41.485491 19.919876 37.822772 18.401738 33.925781 18.400391 z M 27.705078 24.882812 C 27.997395 24.882812 28.289387 24.883804 28.544922 24.896484 C 28.814177 24.910039 29.177172 24.793288 29.533203 25.648438 C 29.898662 26.526733 30.775179 28.686739 30.884766 28.90625 C 30.994521 29.125761 31.068078 29.38296 30.921875 29.675781 C 30.775674 29.96835 30.703718 30.15021 30.484375 30.40625 C 30.265117 30.662375 30.023547 30.977295 29.826172 31.173828 C 29.606577 31.392498 29.376941 31.631207 29.632812 32.070312 C 29.8886 32.509418 30.770368 33.944469 32.074219 35.107422 C 33.749504 36.601829 35.161009 37.065646 35.599609 37.285156 C 36.038295 37.504836 36.294994 37.468434 36.550781 37.175781 C 36.806568 36.88296 37.647053 35.8941 37.939453 35.455078 C 38.231939 35.016225 38.523794 35.089958 38.925781 35.236328 C 39.327854 35.38278 41.485227 36.444636 41.923828 36.664062 C 42.362513 36.883741 42.654001 36.992715 42.763672 37.175781 C 42.873343 37.358679 42.873271 38.23697 42.507812 39.261719 C 42.142269 40.286215 40.389568 41.221824 39.546875 41.347656 C 38.791212 41.46061 37.835828 41.507808 36.785156 41.173828 C 36.148255 40.97174 35.331621 40.700031 34.285156 40.248047 C 29.885176 38.348117 27.010359 33.91969 26.791016 33.626953 C 26.571673 33.334216 25 31.246891 25 29.087891 C 25 26.929143 26.133169 25.870746 26.535156 25.431641 C 26.937228 24.992619 27.412678 24.882813 27.705078 24.882812 z"
			clipRule="evenodd"
		/>
	</svg>
);

export const LinkedIn = () => (
	<svg
		version="1.2"
		baseProfile="tiny"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="16 -16 67 67"
	>
		<path
			fill="#007AB9"
			d="M66.8 31.1V19.4c0-6.3-3.4-9.2-7.8-9.2-3.6 0-5.2 2-6.1 3.4v-2.9h-6.8c.1 1.9 0 20.4 0 20.4h6.8V19.7c0-.6 0-1.2.2-1.7.5-1.2 1.6-2.5 3.5-2.5 2.5 0 3.4 1.9 3.4 4.6V31l6.8.1zM39 7.9c2.4 0 3.8-1.6 3.8-3.5 0-2-1.5-3.5-3.8-3.5s-3.8 1.5-3.8 3.5 1.4 3.5 3.8 3.5zM50 47c-16.6 0-30-13.4-30-30s13.4-30 30-30S80 .4 80 17 66.6 47 50 47zm-7.6-15.9V10.7h-6.8v20.4h6.8z"
		/>
	</svg>
);

export const EMail = () => (
	<svg viewBox="0 0 67 67">
		<path
			fill="#666666"
			fillRule="evenodd"
			strokeWidth="0"
			d="m 33.5,3.5 a 30,30 0 0 0 -30,30 30,30 0 0 0 30,30 30,30 0 0 0 30,-30 30,30 0 0 0 -30,-30 z m 14.408203,15.9043 c 1.754056,0 3.132813,1.3787 3.132813,3.1328 l 0,21.9258 c 0,1.754 -1.378757,3.1328 -3.132813,3.1328 l -28.816406,0 c -1.754056,0 -3.132813,-1.3788 -3.132813,-3.1328 l 0,-21.9258 c 0,-0.877 0.37565,-1.692 0.939454,-2.1933 l 0,-0.061 c 0.06264,0 0.06235,-0.062 0.125,-0.062 0.563803,-0.5012 1.253976,-0.8145 2.068359,-0.8145 l 28.816406,0 0,0 z m -28.816406,1.2539 c -0.250579,0 -0.501373,0.065 -0.751953,0.127 L 33.5,35.9453 48.597656,20.7852 c -0.187934,-0.063 -0.438873,-0.127 -0.689453,-0.127 l -28.816406,0 z m -1.628906,1.0039 c -0.187929,0.2505 -0.25,0.5638 -0.25,0.877 l 0,21.9257 c 0,0.2507 0.06235,0.4995 0.125,0.6875 L 29.177734,33.375 17.462891,21.6621 Z m 32.074218,0 -11.714843,11.7129 11.839843,11.8398 c 0.06264,-0.2506 0.125,-0.4993 0.125,-0.75 l 0,-21.9257 c 0,-0.3132 -0.06207,-0.6265 -0.25,-0.877 z M 30.054688,34.2539 18.214844,46.0938 c 0.250579,0.1885 0.563728,0.25 0.876953,0.25 l 28.816406,0 c 0.313224,0 0.626519,-0.062 0.814453,-0.25 L 36.882812,34.2539 34.064453,37.0723 c -0.06264,0.2505 -0.251229,0.4375 -0.564453,0.4375 -0.250579,0 -0.501803,-0.187 -0.564453,-0.4375 l -0.0625,0 -2.818359,-2.8184 z"
			clipRule="evenodd"
		/>
	</svg>
);

export const Weibo = () => (
	<svg viewBox="0 0 48 48">
		<path d="m24 2a22 22 0 0 0-22 22 22 22 0 0 0 22 22 22 22 0 0 0 22-22 22 22 0 0 0-22-22zm7.7304 9.8554c3.9352 0.26428 6.762 3.287 7.0586 7.125 0.1278 1.6568-0.1521 3.641-1.2461 3.7382-1.7856 0.1596-0.85544-1.8043-0.83204-2.9882 0.0654-3.4318-2.8648-5.8164-5.7344-5.8164-0.813 0-2.701 0.55034-2.4102-1.1641 0.1308-0.756 0.77286-0.74664 1.4141-0.83204 0.60328-0.08045 1.1878-0.10025 1.75-0.0625zm-10.168 3.246c2.224 0.0073 2.827 2.2478 2.1016 4.461 1.7822-0.1196 5.56-2.111 7.2304-0.16797 0.7362 0.8562 0.454 2.3904 0 3.5742 2.0748 1.1352 4.5696 1.7015 4.1562 5.0704-0.099 0.8072-0.58984 1.8854-1.082 2.5742-3.5072 4.9096-14.086 6.9738-20.692 3.2422-2.2154-1.2522-4.5062-3.082-4.1524-6.7304 0.3044-3.1398 2.4164-5.5728 4.4882-7.6446 1.9764-1.9776 4.0586-3.5252 6.8946-4.2382 0.3846-0.0967 0.73698-0.14167 1.0547-0.14063zm9.25 0.80468c2.1044-0.1602 3.657 1.2898 3.9024 3.0742 0.1742 1.2652-0.18416 2.3618-0.91016 2.4102-1.2104 0.0806-0.75844-0.82816-0.83204-1.9102-0.046-0.6664-0.59984-1.4381-1.082-1.6641-0.9456-0.4428-2.4102 0.3233-2.4102-0.9961 0-0.9796 0.85164-0.87746 1.332-0.91406zm-8.5624 6.4454c-0.53416-0.0176-1.0624-7e-3 -1.5742 0.03516-2.2396 0.1836-3.7484 0.65944-5.3204 1.582-1.2828 0.753-2.783 1.9769-3.1562 3.8204-0.8402 4.1454 3.6694 6.095 6.9804 6.3164 3.8258 0.2574 7.6546-1.096 9.4726-3.1602 0.6648-0.7536 1.3323-1.9005 1.3281-3.2382-0.0076-3.6134-3.9914-5.2326-7.7304-5.3554zm-1.1172 2.336c1.9654 0.08784 3.399 1.2019 3.8632 2.6016 1.7704 5.3506-7.4538 7.8404-9.1406 3.2422-1.1286-3.075 1.5799-5.521 4.4024-5.8164 0.30122-0.03158 0.59422-0.0399 0.875-0.02734zm0.16798 2.8124c-0.28048 0.05256-0.54676 0.28312-0.54296 0.70312 0.3756 0.65 1.2401 0.18318 1.1641-0.33204-0.0453-0.2982-0.34062-0.42364-0.6211-0.3711zm-1.8594 0.73438c-0.2153-0.02818-0.46912-0.0138-0.76172 0.05468-1.9664 0.4592-1.5858 3.2572 0.58204 2.7422 1.3569-0.32304 1.6867-2.5996 0.17969-2.7968z" fill="#d34237"/>
	</svg>
);

export const Xing = () => (
	<svg viewBox="0 0 512 512">
		<g transform="scale(0.916666666666667)" transformOrigin="center center">
			<path clip-rule="evenodd" d="M256.23,512C396.81,512,512,396.81,512,256.23   C512,115.184,396.81,0,256.23,0C115.184,0,0,115.184,0,256.23C0,396.81,115.184,512,256.23,512L256.23,512z" fill="#046064" fill-rule="evenodd"/>
			<path clip-rule="evenodd" d="M112.012,127.885h79.812l48.073,80.265l-63.938,112.011H96.139   l63.946-112.011L112.012,127.885z M224.023,287.962L336.034,96.139h80.273L303.835,287.962l80.272,128.346h-80.272L224.023,287.962   z" fill="#FFFFFF" fill-rule="evenodd"/>
		</g>
	</svg>
);

export const Embed = () => (
	<svg viewBox="0 0 67 67">
		<path d="M34 64C17.4 64 4 50.6 4 34S17.4 4 34 4s30 13.4 30 30-13.4 30-30 30z" />
		<path
			fill="#fff"
			d="M24.8 40.8L11.2 34l13.6-6.8v2.2L15.7 34l9.2 4.6v2.2zm5.2 3.4l6.1-20.4h2.1L32 44.2h-2zm13.3-5.6l9.2-4.6-9.2-4.6v-2.2L56.9 34l-13.6 6.8v-2.2z"
		/>
	</svg>
);

export const EmbedSelect = props => (
	<svg {...props} viewBox="0 0 13 16">
		<polygon fill="#32393B" points="6.5,0 0.136,6.364 12.863,6.364" />
		<polygon fill="#32393B" points="0.136,9.636 6.5,16 12.863,9.636" />
	</svg>
);

// Icons for Page Navigation / Decks

export const ArrowLeft = props => (
	<svg
		{...props}
		viewBox="0 0 24 24"
		strokeWidth="1"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<path d="M 17,1 7,12.5 17,23" stroke="white" fill="none" />
	</svg>
);

export const ArrowRight = props => (
	<svg
		{...props}
		viewBox="0 0 24 24"
		strokeWidth="1"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<path d="M 7,1 17,12.5 7,23" stroke="white" fill="none" />
	</svg>
);

// Icons for Decks

export const Indicator = props => (
	<svg {...props} viewBox="0 0 24 24">
		<circle
			cx="12"
			cy="12"
			r="9"
			fill="none"
			stroke="black"
			opacity="0.4"
			strokeWidth="2"
		/>
		<circle cx="10" cy="10" r="9" fill="none" stroke="white" strokeWidth="2" />
	</svg>
);

export const IndicatorActive = props => (
	<svg {...props} viewBox="0 0 24 24">
		<circle cx="12" cy="12" r="10" fill="black" opacity="0.4" />
		<circle cx="10" cy="10" r="10" fill="white" />
	</svg>
);

// Cockpit

export const Time = props => (
	<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path d="M12.516 6.984v5.25l4.5 2.672-0.75 1.266-5.25-3.188v-6h1.5zM12 20.016q3.281 0 5.648-2.367t2.367-5.648-2.367-5.648-5.648-2.367-5.648 2.367-2.367 5.648 2.367 5.648 5.648 2.367zM12 2.016q4.125 0 7.055 2.93t2.93 7.055-2.93 7.055-7.055 2.93-7.055-2.93-2.93-7.055 2.93-7.055 7.055-2.93z"></path>
	</svg>
);

export const Checkmark = props => (
	<svg {...props} viewBox="0 0 32 32">
		<path d="M21.82 13.030l-1.002-1.002c-0.185-0.185-0.484-0.185-0.668 0l-6.014 6.013-2.859-2.882c-0.186-0.185-0.484-0.185-0.67 0l-1.002 1.003c-0.185 0.185-0.185 0.484 0 0.668l4.193 4.223c0.185 0.184 0.484 0.184 0.668 0l7.354-7.354c0.186-0.185 0.186-0.484 0-0.669zM16 3c-7.18 0-13 5.82-13 13s5.82 13 13 13 13-5.82 13-13-5.82-13-13-13zM16 26c-5.522 0-10-4.478-10-10 0-5.523 4.478-10 10-10 5.523 0 10 4.477 10 10 0 5.522-4.477 10-10 10z" />
	</svg>
);

export const Tick = props => (
	<svg {...props} viewBox="0 0 32 32">
		<path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" />
	</svg>
);

export const Cancel = props => (
	<svg {...props} viewBox="0 0 32 32">
		<path d="M16 29c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13-5.82 13-13 13zM16 6c-5.522 0-10 4.478-10 10s4.478 10 10 10c5.523 0 10-4.478 10-10s-4.477-10-10-10zM20.537 19.535l-1.014 1.014c-0.186 0.186-0.488 0.186-0.675 0l-2.87-2.87-2.87 2.87c-0.187 0.186-0.488 0.186-0.675 0l-1.014-1.014c-0.186-0.186-0.186-0.488 0-0.675l2.871-2.869-2.871-2.87c-0.186-0.187-0.186-0.489 0-0.676l1.014-1.013c0.187-0.187 0.488-0.187 0.675 0l2.87 2.87 2.87-2.87c0.187-0.187 0.489-0.187 0.675 0l1.014 1.013c0.186 0.187 0.186 0.489 0 0.676l-2.871 2.87 2.871 2.869c0.186 0.187 0.186 0.49 0 0.675z" />
	</svg>
);

export const Close = props => (
	<svg {...props} viewBox="0 0 32 32">
		<path d="M19.587 16.001l6.096 6.096c0.396 0.396 0.396 1.039 0 1.435l-2.151 2.151c-0.396 0.396-1.038 0.396-1.435 0l-6.097-6.096-6.097 6.096c-0.396 0.396-1.038 0.396-1.434 0l-2.152-2.151c-0.396-0.396-0.396-1.038 0-1.435l6.097-6.096-6.097-6.097c-0.396-0.396-0.396-1.039 0-1.435l2.153-2.151c0.396-0.396 1.038-0.396 1.434 0l6.096 6.097 6.097-6.097c0.396-0.396 1.038-0.396 1.435 0l2.151 2.152c0.396 0.396 0.396 1.038 0 1.435l-6.096 6.096z" />
	</svg>
);

export const ExternalLink = props => (
	<svg {...props} viewBox="0 0 24 32">
		<path
			fill="#000"
			d="M20 24h-16v-15.94l4-0.060v-4h-8v24h24v-10h-4v6zM12 4l4 4-6 6 4 4 6-6 4 4v-12h-12z"
		/>
	</svg>
);

export const Triangle = props => (
	<svg {...props} height="24" width="32" viewBox="0 0 32 24">
		<polygon fill="#000" points="0,24 16,0 32,24" />
	</svg>
);

export const Cross = props => (
	<svg {...props} height="16" width="16" viewBox="0 0 16 16">
		<line x1="0" y1="8" x2="16" y2="8" stroke="#000" strokeWidth="2" />
		<line x1="8" y1="16" x2="8" y2="0" stroke="#000" strokeWidth="2" />
	</svg>
);

export const Camera = props => (
	<svg {...props} width="32" height="32" viewBox="0 0 32 32">
		<path d="M9.5 19c0 3.59 2.91 6.5 6.5 6.5s6.5-2.91 6.5-6.5-2.91-6.5-6.5-6.5-6.5 2.91-6.5 6.5zM30 8h-7c-0.5-2-1-4-3-4h-8c-2 0-2.5 2-3 4h-7c-1.1 0-2 0.9-2 2v18c0 1.1 0.9 2 2 2h28c1.1 0 2-0.9 2-2v-18c0-1.1-0.9-2-2-2zM16 27.875c-4.902 0-8.875-3.973-8.875-8.875s3.973-8.875 8.875-8.875c4.902 0 8.875 3.973 8.875 8.875s-3.973 8.875-8.875 8.875zM30 14h-4v-2h4v2z" />
	</svg>
);

export const Bin = props => (
	<svg {...props} width="32" height="32" viewBox="0 0 32 32">
		<path d="M4 10v20c0 1.1 0.9 2 2 2h18c1.1 0 2-0.9 2-2v-20h-22zM10 28h-2v-14h2v14zM14 28h-2v-14h2v14zM18 28h-2v-14h2v14zM22 28h-2v-14h2v14z" />
		<path d="M26.5 4h-6.5v-2.5c0-0.825-0.675-1.5-1.5-1.5h-7c-0.825 0-1.5 0.675-1.5 1.5v2.5h-6.5c-0.825 0-1.5 0.675-1.5 1.5v2.5h26v-2.5c0-0.825-0.675-1.5-1.5-1.5zM18 4h-6v-1.975h6v1.975z" />
	</svg>
);

export const Envelope = props => (
	<svg {...props} width="20" height="20" viewBox="0 0 20 20">
		<path d="M1.574 5.286c0.488 0.262 7.248 3.894 7.5 4.029s0.578 0.199 0.906 0.199c0.328 0 0.654-0.064 0.906-0.199s7.012-3.767 7.5-4.029c0.489-0.263 0.951-1.286 0.054-1.286h-16.919c-0.897 0-0.435 1.023 0.053 1.286zM18.613 7.489c-0.555 0.289-7.387 3.849-7.727 4.027s-0.578 0.199-0.906 0.199-0.566-0.021-0.906-0.199-7.133-3.739-7.688-4.028c-0.39-0.204-0.386 0.035-0.386 0.219s0 7.293 0 7.293c0 0.42 0.566 1 1 1h16c0.434 0 1-0.58 1-1 0 0 0-7.108 0-7.292s0.004-0.423-0.387-0.219z" />
	</svg>
);

export const Heart = props => (
	<svg {...props} width="54" height="54" viewBox="0 0 54 54">
		<path d="m14.41 4c-2.1 0-4.2 0.40078-6 1.3008-3.7 1.7-6.3 4.5992-7.5 8.1992-1.4 4.3-0.69883 9.3008 2.2012 14.301 3.9 6.8 10.7 11.999 22 20.699l1.9004 1.5 1.8984-1.5c11.3-8.6 18.1-13.899 22-20.699 2.8-5 3.6012-10.001 2.2012-14.301-1.2-3.6-3.9-6.4992-7.5-8.1992-1.9-0.9-3.9996-1.3008-6.0996-1.3008-5.1 0-9.9016 2.5-12.602 6.5-2.6-4-7.4-6.5-12.5-6.5z" />
	</svg>
);

export const EmptyHeart = props => (
	<svg {...props} width="54" height="54" viewBox="0 0 54 54">
		<path d="m27.011 50-1.9-1.5c-11.3-8.7-18.1-13.9-22-20.7-2.9-5-3.6-10-2.2-14.3 1.2-3.6 3.8-6.5 7.5-8.2 1.8-0.9 3.9-1.3 6-1.3 5.1 0 9.9 2.5 12.5 6.5 2.7-4 7.5-6.5 12.6-6.5 2.1 0 4.2 0.4 6.1 1.3 3.6 1.7 6.3 4.6 7.5 8.2 1.4 4.3 0.6 9.3-2.2 14.3-3.9 6.8-10.7 12.1-22 20.7zm-12.6-44c-1.8 0-3.6 0.4-5.2 1.1-3.1 1.4-5.4 3.9-6.4 7-1.2 3.8-0.5 8.2 2.1 12.7 3.6 6.5 10.3 11.7 21.4 20.2l0.7 0.5 0.6-0.5c11.1-8.5 17.8-13.7 21.5-20.2 2.6-4.5 3.3-8.9 2.1-12.7-1-3.1-3.3-5.6-6.4-7-1.7-0.7-3.4-1.1-5.3-1.1-5 0-9.7 2.8-11.6 6.9l-0.9 2-0.9-2c-2-4.1-6.7-6.9-11.7-6.9z" />
	</svg>
);

export const InfoCircled = props => (
	<svg {...props} version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path d="M11.016 9v-2.016h1.969v2.016h-1.969zM12 20.016q3.281 0 5.648-2.367t2.367-5.648-2.367-5.648-5.648-2.367-5.648 2.367-2.367 5.648 2.367 5.648 5.648 2.367zM12 2.016q4.125 0 7.055 2.93t2.93 7.055-2.93 7.055-7.055 2.93-7.055-2.93-2.93-7.055 2.93-7.055 7.055-2.93zM11.016 17.016v-6h1.969v6h-1.969z"></path>
	</svg>
);

export const QuestionCircled = props => (
	<svg {...props} width="24" height="24" viewBox="0 0 24 24">
		<path d="M12 6c2.203 0 3.984 1.781 3.984 3.984 0 2.484-3 2.766-3 5.016h-1.969c0-3.234 3-3 3-5.016 0-1.078-0.938-1.969-2.016-1.969s-2.016 0.891-2.016 1.969h-1.969c0-2.203 1.781-3.984 3.984-3.984zM12 20.016c4.406 0 8.016-3.609 8.016-8.016s-3.609-8.016-8.016-8.016-8.016 3.609-8.016 8.016 3.609 8.016 8.016 8.016zM12 2.016c5.531 0 9.984 4.453 9.984 9.984s-4.453 9.984-9.984 9.984-9.984-4.453-9.984-9.984 4.453-9.984 9.984-9.984zM11.016 18v-2.016h1.969v2.016h-1.969z" />
	</svg>
);

export const MagnifyingGlass = props => (
	<svg
		{...props}
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		width="32"
		height="32"
		viewBox="0 0 32 32"
	>
		<path d="M31.008 27.231l-7.58-6.447c-0.784-0.705-1.622-1.029-2.299-0.998 1.789-2.096 2.87-4.815 2.87-7.787 0-6.627-5.373-12-12-12s-12 5.373-12 12 5.373 12 12 12c2.972 0 5.691-1.081 7.787-2.87-0.031 0.677 0.293 1.515 0.998 2.299l6.447 7.58c1.104 1.226 2.907 1.33 4.007 0.23s0.997-2.903-0.23-4.007zM12 20c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8z" />
	</svg>
);

export const Eye = props => (
	<svg
		{...props}
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24">
	<path d="M12 9q1.219 0 2.109 0.891t0.891 2.109-0.891 2.109-2.109 0.891-2.109-0.891-0.891-2.109 0.891-2.109 2.109-0.891zM12 17.016q2.063 0 3.539-1.477t1.477-3.539-1.477-3.539-3.539-1.477-3.539 1.477-1.477 3.539 1.477 3.539 3.539 1.477zM12 4.5q3.703 0 6.703 2.063t4.313 5.438q-1.313 3.375-4.313 5.438t-6.703 2.063-6.703-2.063-4.313-5.438q1.313-3.375 4.313-5.438t6.703-2.063z"></path>
	</svg>
);

export const Lock = props => (
	<svg
		{...props}
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24">
	<path d="M15.094 8.016v-2.016q0-1.266-0.914-2.18t-2.18-0.914-2.18 0.914-0.914 2.18v2.016h6.188zM12 17.016q0.797 0 1.406-0.609t0.609-1.406-0.609-1.406-1.406-0.609-1.406 0.609-0.609 1.406 0.609 1.406 1.406 0.609zM18 8.016q0.797 0 1.406 0.586t0.609 1.383v10.031q0 0.797-0.609 1.383t-1.406 0.586h-12q-0.797 0-1.406-0.586t-0.609-1.383v-10.031q0-0.797 0.609-1.383t1.406-0.586h0.984v-2.016q0-2.063 1.477-3.539t3.539-1.477 3.539 1.477 1.477 3.539v2.016h0.984z"></path>
	</svg>
);

export const PDF = props => (
	<svg 
		{...props}
		version="1.1"
		xmlns="http://www.w3.org/2000/svg" 
		width="24"
		height="24"
		viewBox="0 0 24 24">
		<path strokeWidth="0" d="M20.118,24H3.882c-0.84,0-1.524-0.684-1.524-1.524V1.524C2.358,0.684,3.042,0,3.882,0h12.317  c0.135,0,0.265,0.054,0.36,0.149l4.934,4.952c0.095,0.095,0.148,0.224,0.148,0.359v17.016C21.642,23.316,20.958,24,20.118,24z   M3.882,1.016c-0.28,0-0.508,0.228-0.508,0.508v20.952c0,0.28,0.228,0.508,0.508,0.508h16.236c0.28,0,0.508-0.228,0.508-0.508V5.67  l-4.637-4.654H3.882z"></path>
		<path strokeWidth="0" d="M20.644,6.476h-4.571c-0.281,0-0.508-0.227-0.508-0.508V0.596c0-0.281,0.227-0.508,0.508-0.508  c0.281,0,0.508,0.227,0.508,0.508V5.46h4.063c0.281,0,0.508,0.227,0.508,0.508S20.924,6.476,20.644,6.476z"></path>
		<path strokeWidth="0" d="M6.716,18.567v1.864H5.844v-5.018h1.92c1.165,0,1.83,0.673,1.83,1.597c0,0.975-0.665,1.558-1.83,1.558H6.716z M6.716,17.867  h1.048c0.676,0,0.955-0.352,0.955-0.852c0-0.469-0.279-0.899-0.955-0.899H6.716V17.867z"></path>
		<path strokeWidth="0" d="M10.356,20.431v-5.018h1.482c1.337,0,2.261,0.938,2.261,2.388v0.248c0,1.448-0.91,2.382-2.302,2.382H10.356z M11.228,16.116  v3.619h0.569c0.951,0,1.427-0.634,1.427-1.686v-0.254c0-1.089-0.486-1.679-1.386-1.679H11.228z"></path>
		<path strokeWidth="0" d="M17.859,18.305h-2.02v2.126h-0.872v-5.018h3.188v0.703H15.84v1.492h2.02V18.305z"></path>
	</svg>
);

export const UpArrow = props => (
	<svg
		{...props} 
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 70 70"
		width="70"
		height="70"
		>
		<path d="m7.8466 6.9855c-2.6672 0.12449-2.4797 4.1245 0.1875 4h54c2.7046 0.03821 2.7046-4.0382 0-4h-54c-0.06247-0.00293-0.12503-0.00293-0.1875 0zm26.875 10c-0.38516 0.06251-0.74363 0.23631-1.0312 0.5l-22 20c-1.9792 1.7917 0.70833 4.7604 2.6875 2.9688l18.656-16.969v37.5c-0.01493 1.0566 0.94328 2.0312 2 2.0312s2.0149-0.97465 2-2.0312v-37.5l18.656 16.969c1.9792 1.7917 4.6667-1.1771 2.6875-2.9688l-22-20c-0.44772-0.40916-1.0569-0.59306-1.6562-0.5z"/>
	</svg>
);

export const Logout = props => (
	<svg 
		{...props}
		version="1.1" 
		viewBox="0 0 24 24" 
		width="24"
		height="24"
		xmlns="http://www.w3.org/2000/svg"
		>
		<path d="m1.5391 0.039062a0.50005 0.50005 0 0 0-0.11719 0.013672 0.50005 0.50005 0 0 0-0.056641 0.017578 0.50005 0.50005 0 0 0-0.19531 0.13281 0.50005 0.50005 0 0 0-0.037109 0.044922 0.50005 0.50005 0 0 0 0 0.0019531 0.50005 0.50005 0 0 0-0.076172 0.1582 0.50005 0.50005 0 0 0 0 0.0019531 0.50005 0.50005 0 0 0-0.017578 0.12891v18.23a0.50005 0.50005 0 0 0 0.20508 0.4043l6.4629 4.6914a0.50005 0.50005 0 0 0 0.79297-0.4043v-4.3457h5.8848a0.50005 0.50005 0 0 0 0.5-0.5v-8.0391h6.1973l-2.8164 2.7598a0.5 0.5 0 0 0-0.007813 0.70703 0.5 0.5 0 0 0 0.70703 0.005859l3.6875-3.6094a0.5 0.5 0 0 0 0.005859-0.005859 0.5 0.5 0 0 0 0.003906-0.003906 0.5 0.5 0 0 0 0.035157-0.039063 0.5 0.5 0 0 0 0.003906-0.003906 0.5 0.5 0 0 0 0.03125-0.044922 0.5 0.5 0 0 0 0.001953-0.003906 0.5 0.5 0 0 0 0.025391-0.048829 0.5 0.5 0 0 0 0.001953-0.003906 0.5 0.5 0 0 0 0.001953-0.005859 0.5 0.5 0 0 0 0.035156-0.10742 0.5 0.5 0 0 0 0.007813-0.054687 0.5 0.5 0 0 0 0-0.003907 0.5 0.5 0 0 0 0-0.054687 0.5 0.5 0 0 0 0-0.00586 0.5 0.5 0 0 0-0.00586-0.052734 0.5 0.5 0 0 0 0-0.0058594 0.5 0.5 0 0 0-0.011719-0.052734 0.5 0.5 0 0 0-0.001953-0.0058593 0.5 0.5 0 0 0-0.017578-0.050781 0.5 0.5 0 0 0-0.029297-0.056641 0.5 0.5 0 0 0-0.021484-0.035156 0.5 0.5 0 0 0-0.009766-0.015625 0.5 0.5 0 0 0-0.035156-0.041016 0.5 0.5 0 0 0-0.003906-0.0039062 0.5 0.5 0 0 0-0.007813-0.0097657l-3.6934-3.6914a0.5 0.5 0 0 0-0.35742-0.14648 0.5 0.5 0 0 0-0.34961 0.14648 0.5 0.5 0 0 0 0 0.70703l2.8398 2.8379h-6.2168v-9.0371a0.50005 0.50005 0 0 0-0.5-0.5h-12.846zm1.3828 1h10.963v8.5371h-4.2695a0.5 0.5 0 0 0-0.5 0.5 0.5 0.5 0 0 0 0.5 0.5h4.2695v7.5391h-5.3848v-12.191a0.50005 0.50005 0 0 0-0.0039062-0.058594 0.50005 0.50005 0 0 0 0-0.0019532 0.50005 0.50005 0 0 0-0.0097657-0.056641 0.50005 0.50005 0 0 0 0-0.0019531 0.50005 0.50005 0 0 0-0.017578-0.054688 0.50005 0.50005 0 0 0 0-0.0019531 0.50005 0.50005 0 0 0-0.023438-0.052734 0.50005 0.50005 0 0 0 0-0.0019531 0.50005 0.50005 0 0 0-0.03125-0.048828 0.50005 0.50005 0 0 0 0-0.0019531 0.50005 0.50005 0 0 0-0.076172-0.087891 0.50005 0.50005 0 0 0-0.0019531-0.0019531 0.50005 0.50005 0 0 0-0.015625-0.013672l-5.3984-4.5zm-0.88281 0.56641 5.4609 4.5527v12.457 3.8652l-5.4609-3.9668v-16.908z" strokeWidth="0"/>
	</svg>
);


// WEBPACK FOOTER //
// ./lib/components/icons.js